<template>
    <aside class="settings-content settings-customizations">
        <Loading v-if="is_loading" />
        <!-- handle img -->
        <Scrollbar class="data-list" :show_bar="true">
            <div class="title">Customizations</div>
            <Navi :menu="menu" />

            <div v-if="$route.params.type === 'storefront-img'">
                
                <div class="desc-box">
                    <h3>Brand Assets</h3>
                </div>
                <Form :schema="schema" @submit="submit" :values="user_data" v-slot="{ errors, success }" class="user-form-wrap"
                    :class="{ 'is-error': is_error }" ref="form">

                    <!-- Site logo & Favicon -->
                    <div class="item">
                        <div class="flex">
                            <label class="label">Site Logo & Favicon</label>
                        </div>
                        <div class="logo-wrap-box">
                            <div :class="['logo-wrap']" v-for="(v, k) in img_arr.slice(0, 2)" :key="k">
                                <div :class="['text', v.text_class]">
                                    <h4 v-html="v.name"></h4>
                                    <p v-html="v.text"></p>
                                    <p class="error-msg" v-if="v.is_error" v-html="v.error_msg"></p>
                                    <el-button v-if="!$store.state.merchant_disabeld && permission_appearance==100" size="small"
                                        @click="upload(k)">Upload</el-button>
                                    <el-button v-if="v.is_reset && v.img && !$store.state.merchant_disabeld && permission_appearance==100" class="reset" size="small" text @click="saveReset(v)">Save</el-button>
                                    <el-button v-if="!v.is_reset && v.img && v.img.indexOf('.com/default-') === -1 && !$store.state.merchant_disabeld && permission_appearance==100"
                                        class="reset" size="small" text
                                        @click="resetImg(v)">Reset</el-button>
                                </div>

                                <div :class="['img-wrap ', v.img_class, { 'have-image': v.img }]" v-if="permission_appearance==100">
                                    <input class="avatar-input" type="file" ref="file" @change="loadImage($event, v.field)"
                                        accept="image/png" v-if="!$store.state.merchant_disabeld">
                                    <img v-if="v.img" :src="v.img" />
                                    <div v-else :class="['img-wrap img-wrap-default', v.img_class]">
                                        {{ $store.state.user_data.merchant_account.merchant_display_name[0] }}
                                    </div>
                                    <i v-if="!$store.state.merchant_disabeld">
                                        <SvgIcon name="pen" />
                                    </i>
                                </div>
                                <div :class="['img-wrap ', v.img_class, { 'have-image': v.img }]" v-else>
                                    <img v-if="v.img" :src="v.img" />
                                </div>
                            </div>
                        </div>
                    </div>

                </Form>
            </div>

            <div v-else-if="$route.params.type === 'permissions'">
                <div class="desc-box">
                    <!-- <p>Appearance & Permissions</p> -->
                    <h3>Creator Permissions</h3>
                </div>

                <!-- Creator permissions -->
                <div :class="['item', $store.state.merchant_disabeld && 'disabeld-box']">
                    <!-- <div class="flex">
                        <label class="label">Creator permissions</label>
                    </div> -->
                    <div class="logo-wrap logo-wrap-3">
                        <div class="text text2">Storefront Collections</div>
                        <div class="right">
                            <Checkbox :disabled="permission_permission!==100" label_text="Enable creators to upload custom cover images on their storefront collections."
                                :checked="values.creator_collection" @click.native="handleAllowCus()" :align_start="true" />
                        </div>
                    </div>
                    <!-- 9122 -->
                    <div class="logo-wrap logo-wrap-3" v-if="values.show_post_content">
                        <div class="text text2">Storefront Posts</div>
                        <div class="right">
                            <Checkbox :disabled="permission_permission!==100" label_text="Enable creators to upload social media content on their storefronts."
                                :checked="values.post_content" @click.native="handleAllowPostConent()" :align_start="true" />
                        </div>
                    </div>

                    <!-- 10127 -->
                    <div class="logo-wrap logo-wrap-3 logo-wrap-3-sup"  v-if="values.show_post_content && show_post_image">
                        <div :class="['text text2', !values.post_content && 'disabled-text']">Storefront Image Posts</div>
                        <div class="right">
                            <Checkbox label_text="Enable creators to upload image posts on their storefronts."
                                :disabled="!values.post_content || permission_permission!==100"
                                :checked="!values.post_content ? false: values.post_image" @click.native="handleAllowPostImage()" :align_start="true" />
                        </div>
                    </div>
                </div>
            </div>

            <div v-else-if="$route.params.type === 'content-listening'">
                <div class="desc-box" >
                    <h3>Track & Analyze Creator Content</h3>
                </div>
                <div class="item item2"></div>
                <Hashtag />

            </div>
            
            <div v-else-if="$route.params.type === 'term-setting'">
                <div class="desc-box">
                    <h3>Policies</h3>
                </div>

              <div class="item">
                <TermTemplate/>
              </div>
            </div>

            <div v-else-if="$route.params.type === 'tiers'">
                <Tiers />
            </div>
        </Scrollbar>
    </aside>
</template>

<script>
import * as yup from 'yup';
import { Cropper } from 'vue-advanced-cropper';
import 'vue-advanced-cropper/dist/style.css';
import Navi from '@/components/Navi.vue';

import Field from '@/components/ui/Field.vue';
import Form from '@/components/ui/Form.vue';
import Button from '@/components/ui/Button.vue';
import Dropdown from '@/components/ui/Dropdown.vue';
import Scrollbar from '@/components/ui/Scrollbar.vue';
import getMimeType from '@/utils/getMimeType';
import Loading from '@/components/ui/Loading.vue';
import SvgIcon from '@/components/ui/SvgIcon.vue';
import SettingAlert from '@/components/settings/SettingAlert.vue';
import Usage from '@/components/ui/Usage.vue';
import Modal from '../ui/Modal.vue';
import Slider from '@/components/settings/Slider.vue';
import Checkbox from '@/components/ui/Checkbox.vue';
import Hashtag from '@/components/Hashtag.vue';
import { ElButton } from 'element-plus';
import TermTemplate from '@/components/settings/TermTemplate.vue';
import Tiers from '@/components/settings/Tiers/Tiers.vue';
import { isTierEnabled } from '@/components/settings/Tiers/tierModel';

export default {
    name: 'Customizations',

    components: {
        Field,
        Form,
        Button,
        Dropdown,
        Scrollbar,
        Cropper,
        Loading,
        SvgIcon,
        SettingAlert,
        Usage,
        Modal,
        Slider,
        Checkbox,
        Navi,
        Hashtag,
        ElButton,
        TermTemplate,
        Tiers,
    },

    data() {
        return {
            img_arr: [
                {
                    name: 'Logo ',
                    field: 'StorefrontLogo',
                    img: null,
                    default_img: require('@/assets/images/company/L.png'),
                    img_class: 'storefront-logo',
                    text_class: '',
                    img_blob: null,
                    is_reset: false,
                    text: `This may appear on your creator storefronts. Please upload a .PNG, 200kb (max).`,
                    image: {
                        src: null,
                        type: null
                    },
                    is_error: false,
                    error_msg: 'Please use 2000x400px dimension PNG format. File size not larger than 200kb.',
                },
                {
                    name: 'Favicon ',
                    field: 'Favicon',
                    img: null,
                    default_img: require('@/assets/images/company/B.png'),
                    img_class: 'favicon-img',
                    text_class: 'favicon-text',
                    img_blob: null,
                    is_reset: false,
                    text: `This will appear on the creator storefronts' browser tabs. Please upload a .PNG, 1:1 (32x32px), 4kb (max).`,
                    image: {
                        src: null,
                        type: null
                    },
                    is_error: false,
                    error_msg: 'Please use 32x32px dimension PNG format. File size not larger than 32kb.',
                },
                {
                    name: 'Hero image',
                    field: 'HeaderHeroImage',
                    img: null,
                    default_img: require('@/assets/images/company/M.png'),
                    img_class: '',
                    text_class: 'hero-text',
                    img_blob: null,
                    is_reset: false,
                    text: `This will be used on your creator storefronts.PNG, 500kb (max)`,
                    image: {
                        src: null,
                        type: null
                    },
                    is_error: false,
                    error_msg: 'Please use 2000x400px dimension PNG format. File size not larger than 500kb.',
                },

            ],
            now_img_key: 0,
            now_img_aspect: 1,
            //page_data filed name need to same with img_arr[index].name
            page_data: {
                StorefrontLogo: {
                    name: 'StorefrontLogo',
                    api: 'store-front-logo',
                    key: 0,
                    now_img_aspect: false
                },
                HeaderHeroImage: {
                    name: 'HeaderHeroImage',
                    api: 'store-front-hero-image',
                    key: 2,
                    now_img_aspect: 1
                },
                Favicon: {
                    name: 'Favicon',
                    api: 'favicon',
                    key: 1,
                    now_img_aspect: 1
                }
            },
            els: [],
            user_data: {
                name: '',
            },
            schema: yup.object().shape({
                name: yup.string().required('The company name can’t leave as blank'),
            }),
            is_error: false,
            is_loading: false,
            //avarar handle
            pre_name: '',
            values: {
                creator_collection: false,
                en_header: true,
                post_content:false,
                post_image:false
            },
            show_post_image: false,
        }
    },

    computed: {
        permission_appearance() {
            return this.$store.state.user_data?.permission_list?.settingCustomization?.editStorefrontAppearance.permission;
        },
        permission_permission() {
            return this.$store.state.user_data?.permission_list?.settingCustomization?.editCreatorStorefrontPermissions.permission;
        },
        permission_policy(){
            //privacySettings
            return this.$store.state.user_data?.permission_list?.settingIntegrations?.privacySettings.permission;
        },
        menu() {
            let me=[
                { text: 'Appearance', to: '/settings/storefront-img' },
                { text: 'Permissions', to: '/settings/permissions' },
                { text: 'Content', to: '/settings/content-listening' },
            ];
            if(this.permission_policy){
                me.push({ text: 'Policies', to: '/settings/term-setting' });
            }
            if(isTierEnabled(this.$store)){
                me.push({ text: 'Tiers', to: '/settings/tiers' });
            }

            return me;
        }
    },

    methods: {
        start() {
            if (this.$store.state.user_data) {
                let company = this.$store.state.user_data.merchant_account;
                this.img_arr[0].img = company.store_front_logo
                this.img_arr[1].img = company.favicon_url;
                this.img_arr[2].img = company.store_front_hero_image;
                this.user_data.name = company.merchant_display_name;
                this.pre_name = company.merchant_display_name;
                this.show_post_image = company.is_allow_use_image_post;
                // is_allow_use_anchor_post  為1的話才顯示那個欄位
                // is_enable_anchor_post  為1的話才會勾選那個欄位

                this.values = {
                    creator_collection: company.is_allow_customize_collection_cover ? true : false,
                    en_header: company.is_show_store_front_hero_image ? true : false,
                    post_content:company.is_enable_anchor_post && company.is_allow_use_anchor_post ? true : false,
                    show_post_content:company.is_allow_use_anchor_post ,
                    post_image: company.is_enable_image_post ? true : false,
                }

                if (this.$route.params.type === 'storefront-img') {
    
                    setTimeout(() => {
                        this.els.forEach(el => {
                            el.sync();
                        });

                        setTimeout(() => {
                            this.$refs.form.init();
                        }, 300);
                    }, 100);
                }
            }
        },

        loadImage(event, name) {
            let vi = this

            if (name == this.page_data[name].name) {
                vi.now_img_key = this.page_data[name].key;
                vi.now_img_aspect = this.page_data[name].now_img_aspect;
            }

            // Reference to the DOM input element
            const { files } = event.target;
            // Ensure that you have a file before attempting to read it
            if (files && files[0]) {
                // 1. Revoke the object URL, to allow the garbage collector to destroy the uploaded before file
                if (this.img_arr[vi.now_img_key].image.src) {
                    URL.revokeObjectURL(this.img_arr[vi.now_img_key].image.src)
                }
                // 2. Create the blob link to the file to optimize performance:
                const blob = URL.createObjectURL(files[0]);

                // Create a new FileReader to read this image binary data
                const reader = new FileReader();
                reader.onload = (e) => {
                    this.img_arr[vi.now_img_key].image = {
                        src: blob,
                        type: getMimeType(e.target.result, files[0].type),
                    };
                };
                reader.readAsArrayBuffer(files[0]);

                // console.log('name:', name)

                switch (name) {

                    case 'StorefrontLogo':
                        const img = new Image();
                        img.onload = () => {
                            const kb = files[0].size / 1024;

                            if (200 >= kb) {
                                this.img_arr[vi.now_img_key].img_blob = files[0];
                                this.img_arr[vi.now_img_key].img = blob;
                                let name = this.img_arr[vi.now_img_key].field;
                                this.img_arr[vi.now_img_key].is_error = false;
                                this.callUpdateApi(name);
                            } else {
                                this.img_arr[vi.now_img_key].is_error = true;
                            }
                        };
                        img.src = URL.createObjectURL(files[0]);
                        break;

                    case 'Favicon':
                        const img1 = new Image();
                        img1.onload = () => {
                            const width = img1.width;
                            const height = img1.height;
                            const kb = files[0].size / 1024;
                            console.log('width',width)
                            console.log('height',height)
                            console.log('kb',kb)
                            if (32 >= kb && width === 32 && height === 32) {
                                this.img_arr[vi.now_img_key].is_error = false;
                                this.img_arr[vi.now_img_key].img_blob = files[0];
                                this.img_arr[vi.now_img_key].img = blob;
                                let name = this.img_arr[vi.now_img_key].field;
                                this.callUpdateApi(name);
                            } else {
                                this.img_arr[vi.now_img_key].is_error = true;
                            }
                        };
                        img1.src = URL.createObjectURL(files[0]);
                        break;

                    case 'HeaderHeroImage':
                        const img2 = new Image();
                        img2.onload = () => {
                            const kb = files[0].size / 1024;

                            if (500 >= kb) {
                                this.img_arr[vi.now_img_key].img_blob = files[0];
                                this.img_arr[vi.now_img_key].img = blob;
                                let name = this.img_arr[vi.now_img_key].field;
                                this.img_arr[vi.now_img_key].is_error = false;
                                this.callUpdateApi(name);
                            } else {
                                this.img_arr[vi.now_img_key].is_error = true;
                            }
                        };
                        img2.src = URL.createObjectURL(files[0]);
                        break;
                }
            }
        },

        submit() {
            this.is_error = false;
            if (this.pre_name !== this.user_data.name) this.callUpdateApi('name');
        },

        callUpdateApi(name) {
            this.is_loading = true;
            //have logo,favicon,name
            let form_data = new FormData();
            let api_name = name;
            if (name === 'name') {
                form_data = this.user_data;
            }

            else if (name === this.page_data.StorefrontLogo.name) {
                form_data.append('store_front_logo', this.img_arr[0].img_blob);
                api_name = this.page_data.StorefrontLogo.api;
                this.img_arr[0].is_reset = false;
            }

            else if (name === this.page_data.Favicon.name) {
                form_data.append('company_favicon', this.img_arr[1].img_blob);
                api_name = this.page_data.Favicon.api;
                this.img_arr[1].is_reset = false;
            }

            else if (name === this.page_data.HeaderHeroImage.name) {
                form_data.append('store_front_hero_image', this.img_arr[2].img_blob);
                api_name = this.page_data.HeaderHeroImage.api;
                this.img_arr[2].is_reset = false;
            }

            //CALL API
            this.$ajax(`/settings/update-company/${api_name}`, {
                method: 'post',
                data: form_data,
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then(res => {
                const resData = res.data.data;
                //.replace(/\\/g, '');
                if (name === this.page_data.StorefrontLogo.name){
                    this.$notify(`<svg><use xlink:href="#yes--sprite"></use></svg> Logo successfully updated.`);
                }else{
                    this.$notify(`<svg><use xlink:href="#yes--sprite"></use></svg> ${name.charAt(0).toUpperCase() + name.slice(1)} successfully.`);
                }
                
                if (name === this.page_data.StorefrontLogo.name)
                    this.$store.state.user_data.merchant_account.store_front_logo = resData.store_front_logo.replace(/\\/g, '');

                if (name === this.page_data.HeaderHeroImage.name)
                    this.$store.state.user_data.merchant_account.store_front_hero_image = resData.store_front_hero_image.replace(/\\/g, '');

                if (name === this.page_data.Favicon.name)
                    this.$store.state.user_data.merchant_account.favicon_url = resData.favicon_url.replace(/\\/g, '');

                this.is_loading = false;
            }).catch(err => {
                this.is_loading = false;
                if (err && err.response && err.response.data.data)
                    this.errNofity(err);
            });
        },

        saveReset(item) {
            const form_data = new FormData();
            this.is_loading = true;


            switch (item.field) {
                case 'StorefrontLogo':
                    form_data.append('image_field_name', 'store_front_logo');
                    break;
                case 'Favicon':
                    form_data.append('image_field_name', 'favicon_url');
                    break;
                case 'HeaderHeroImage':
                    form_data.append('image_field_name', 'store_front_hero_image');
                    break;
            }

            this.$ajax(`/settings/reset-company-logos`, {
                method: 'post',
                data: form_data,
            }).then(res => {
                this.$notify(`<svg><use xlink:href="#yes--sprite"></use></svg> Reset successfully.`);
                item.is_reset = false;
                item.is_error = false;

                switch (item.field) {
                    case 'StorefrontLogo':
                        this.$store.state.user_data.merchant_account.store_front_logo = this.img_arr[0].img;
                        break;
                    case 'Favicon':
                        this.$store.state.user_data.merchant_account.favicon_url = this.img_arr[1].img;
                        break;
                    case 'HeaderHeroImage':
                        this.$store.state.user_data.merchant_account.store_front_hero_image = this.img_arr[2].img;
                        break;
                }

                this.is_loading = false;
            }).catch(err => {
                this.is_loading = false;
                if (err && err.response && err.response.data.data)
                    this.errNofity(err);
            });
        },

        async resetImg(item) {
            this.is_loading = true;
            item.is_reset = true;
            item.is_error = false;

            this.$ajax(`/settings/get-default-company-logos`, {
                method: 'get',
            }).then(res => {
                const resData = res.data.data;

                switch (item.field) {
                    case 'StorefrontLogo':
                        this.img_arr[0].img = resData.store_front_logo;

                        break;
                    case 'Favicon':
                        this.img_arr[1].img = resData.favicon_url;

                        break;
                    case 'HeaderHeroImage':
                        this.img_arr[2].img = resData.store_front_hero_image;

                        break;
                }


                this.is_loading = false;
            });


        },

        errNofity(err) {
            let mes = err.response && err.response.data.data ? err.response.data.data.message : '';
            this.$notify(`<svg class="err-notify"><use xlink:href="#alert--sprite"></use></svg>${mes}`);
        },

        upload(index) {
            if (index === 2) {
                this.$refs.file2.click();
            } else {
                this.$refs.file[index].click();
            }

        },

        handleEnHeader() {
            //ture turn to false,false is 0
            let params_data = {
                is_show_store_front_hero_image: this.values.en_header ? 0 : 1,
            };
            this.is_loading = true;
            this.$ajax(`/settings/update-company/is-show-store-front-hero-image`, {
                method: 'post',
                params: params_data,
            }).then(res => {
                this.values.en_header = !this.values.en_header;
                this.$store.state.user_data.merchant_account.is_show_store_front_hero_image = this.values.en_header;
                this.is_loading = false;
            }).catch(err => {
                this.is_loading = false;
                if (err && err.response && err.response.data.data)
                    this.errNofity(err);
            })
        },

        handleAllowCus() {
            //ture turn to false,false is 0
            let form_data = new FormData();
            form_data.append('is_allow_customize_collection_cover', this.values.creator_collection ? 0 : 1);

            this.is_loading = true;
            this.$ajax(`/settings/update-company/is-allow-customize-collection-cover`, {
                method: 'post',
                data: form_data,
            }).then(res => {
                this.values.creator_collection = !this.values.creator_collection;
                this.$store.state.user_data.merchant_account.is_allow_customize_collection_cover = this.values.creator_collection;
                this.is_loading = false;
            }).catch(err => {
                this.is_loading = false;
                if (err && err.response && err.response.data.data)
                    this.errNofity(err);
            })
        },

        handleAllowPostConent(){
            let form_data = new FormData();
            form_data.append('is_enable_anchor_post', this.values.post_content ? 0 : 1);

            this.is_loading = true;
            this.$ajax(`/settings/update-company/is-enable-anchor-post`, {
                method: 'post',
                data: form_data,
            }).then(res => {
                this.values.post_content = !this.values.post_content;
                this.$store.state.user_data.merchant_account.is_enable_anchor_post = this.values.post_content;
                if(this.values.post_image){
                    this.handleAllowPostImage();
                }
                this.is_loading = false;
            }).catch(err => {
                this.is_loading = false;
                if (err && err.response && err.response.data.data)
                    this.errNofity(err);
            })
        },

        handleAllowPostImage(){
            //is_allow_use_image_post
            let form_data = new FormData();
            form_data.append('is_enable_image_post', this.values.post_image ? 0 : 1);

            this.is_loading = true;
            this.$ajax(`/settings/update-company/is-enable-image-post`, {
                method: 'post',
                data: form_data,
            }).then(res => {
                this.values.post_image = !this.values.post_image;
                this.$store.state.user_data.merchant_account.is_enable_image_post = this.values.post_image;
                this.is_loading = false;
            }).catch(err => {
                this.is_loading = false;
                if (err && err.response && err.response.data.data)
                    this.errNofity(err);
            })
        }

    },

    mounted() {
        this.start()
    },
}
</script>
<style lang="scss">
.settings-customizations {

    .disabeld-box .right{
        opacity: .5;
    }

    .flex {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .data-list {
        padding-bottom: 20px;
    }

    .logo-wrap {
        display: flex;
        align-items: flex-start;
        margin: 24px 0;
        min-height: 64px;

        &:first-child {
            margin-top: 0;
        }

        &.logo-wrap-2 {
            margin-top: 11px;
        }

        &.logo-wrap-3 {
            margin-top: 0;
        }

        .img-wrap {
            width: 400px;
            height: auto;
            border: 1px solid rgba(0, 0, 0, 0.1);
            position: relative;

            img {
                width: 100%;
                height: auto;
                object-fit: contain;
                display: block;
            }

            .avatar-input {
                position: absolute;
                height: 100%;
                width: 100%;
                left: 0;
                opacity: 0;
                top: 0;
                z-index: 3;
                cursor: pointer;
            }

            i {
                position: absolute;
                height: 24px;
                width: 24px;
                border-radius: 50%;
                border: solid 1px var(--dark-blue);
                background: white;
                display: flex;
                align-items: center;
                justify-content: center;
                right: 5px;
                top: 5px;

                svg {
                    height: 12px;
                    width: 12px;
                    position: relative;
                    fill: var(--dark-blue);
                }
            }

            &.have-image {
                // border: none;

                input {
                    left: auto !important;
                    height: calc(100% + 15px) !important;
                    width: calc(100% + 15px) !important;
                    right: -15px !important;
                    top: -15px !important;
                }

                i {
                    right: -10px;
                    top: -10px;
                }
            }
        }

        .img-wrap-default {
            background-color: var(--black-20);
            color: var(--black-60);
            display: flex;
            justify-content: center;
            align-items: center;
            font-family: var(--font-med);
            font-size: 54px;
        }

        .storefront-logo {
            width: 300px;
            height: auto;
            min-height: 64px;
            display: flex;
            align-items: center;
            justify-content: center;
        }

        .favicon-img {
            width: 32px;
            height: 32px;
        }

        .text {
            font-family: var(--font);
            font-size: 14px;
            line-height: 18px;
            color: var(--black-60);
            padding-right: 16px;
            max-width: 240px;
            min-width: 240px;

            h4 {
                margin-bottom: 6px;
                font: var(--font-med-14);
                color: var(--black-100);

                &+p {
                    margin-bottom: 10px;
                }
            }

            .h4 {
                margin-bottom: 10px;
            }

            .error-msg {
                color: var(--alert);
                margin: 10px 0;
            }


            .reset {
                border: none;
                font-size: 12px;
                margin-left: 12px;
            }

            &.text2 {
                font: var(--font-med-14);
                color: var(--black-90);
            }
        }

        &.logo-wrap-3-sup {
            border-left: solid 2px var(--black-20);
            padding-left: 8px;
            margin: 0 16px;
            margin-top: -16px;
            min-height: unset;
            align-items: center;

            .text{
                min-width: 214px;

                &.disabled-text{
                    color: var(--black-50);
                }
            }
        }

    }

    .desc-box {
        margin: 24px 0;

        p {
            font-family: var(--font-med-16);
            color: var(--black-75);
            margin-bottom: 7px;
        }

        h3 {
            font: var(--font-med-20);
            color: var(--black-90);
            margin-bottom: 12px;
        }
    }

    .item {
        font-weight: 400;
        // margin-top: 12px;
        border-top: solid 1px var(--black-20);
        padding-top: 24px;

        &.item2{
            padding-top: 0;
        }

        .label {
            font: var(--font-med-20);
            margin: 0 0 24px;
        }

        .ui-checkbox {
            margin: 0;
            font: var(--font-med-14);
            color: var(--black-90);

            svg {
                min-width: 16px;
            }
        }

        .name {
            margin-top: 1.2rem;
            display: flex;
            align-items: center;

            strong {
                font: var(--font-fg-14);
            }

            span {
                margin-left: .5rem;
                color: var(--blue);
                cursor: pointer;
                font: var(--font-fg-12);

                &:hover {
                    text-decoration: underline;
                }
            }
        }

        .input-wrap {
            margin-top: .8rem;
            display: flex;
            align-items: center;

            span {
                margin: 0 1rem;
                color: var(--blue);
                cursor: pointer;
                font: var(--font-fg-12);

                &:hover {
                    text-decoration: underline;
                }
            }

            .ui-input {
                margin: 0;
                min-width: 250px;

                .err-msg-box {
                    position: absolute;
                }

                input {
                    padding: 8px;
                }
            }
        }


        .no-required {
            &:after {
                content: '';
            }
        }
    }
}


.logo-cropper-wrap {
    $size: 540px;
    position: fixed;
    z-index: 999;
    height: 100%;
    left: 0;
    top: 0;
    width: 100%;
    background-color: rgba(#fff, .5);
    backdrop-filter: blur(5px);

    i {
        cursor: pointer;
        height: 14px;
        width: 14px;
        display: block;

        svg {
            display: block;
            height: 100%;
            width: 100%;
            fill: var(--black-50);
        }

        &:hover svg {
            fill: var(--dark-blue);
        }
    }

    .cropper-box {
        width: $size;
        background-color: white;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        box-shadow: var(--bot-4dp);
        border-radius: 16px;

        header {
            padding: 12px 18px;
            display: flex;
            align-items: center;

            h2 {
                flex: 1;
                font-size: 20px;
                font-family: var(--font-med);
                color: var(--neureal);
            }
        }

        footer {
            padding: 18px;

            .control {
                display: flex;
                align-items: center;
                justify-content: center;

                span {
                    padding-right: 5px;
                    color: var(--dark-blue);
                }

                .slider {
                    display: flex;
                    align-items: center;
                    width: 240px;
                    margin: 0 12px;

                    i {
                        height: 24px;
                        width: 24px;
                        border-radius: 50%;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        margin: 0 3px;

                        svg {
                            height: 18px;
                            width: 18px;
                            position: relative;
                            fill: var(--dark-blue);
                        }
                    }
                }

                .rotate {
                    display: flex;
                    align-items: center;
                    margin: 0 12px;

                    i {
                        height: 24px;
                        width: 24px;
                        border: 1px solid var(--dark-blue);
                        border-radius: 50%;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        margin: 0 6px;

                        svg {
                            height: 14px;
                            width: 14px;
                            position: relative;
                            fill: var(--dark-blue);
                        }
                    }
                }

                .vue3-slider .handle {
                    height: 11px !important;
                    width: 11px !important;
                    transform: scale(1) !important;
                    margin-top: -5px;
                    margin-left: -5px;
                    border-radius: 50%;
                    background-color: var('');
                }
            }

            .text {
                color: var(--black-60);
                margin: 20px 0 10px;
            }

            .btns {
                display: flex;
                align-items: center;
                justify-content: flex-end;
            }

            .ui-button {
                margin: 0 6px;
            }

            // .ui-button {
            //     width: 80px;
            //     display: block;
            //     text-align: center;
            //     margin: 12px auto 0;
            // }
        }
    }

    .box {
        width: $size;
        height: $size * .75;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: var(--black-100);
    }

    .vue-bounding-box {
        border-radius: 50%;
        overflow: hidden;
    }
}
</style>

